import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setActionBtnTitle, setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { BannerTypeWidget } from 'widgets/content/ui/banner-type/BannerTypeWidget';

export const BannerTypePage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Типы баннеров'));
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Создать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <BannerTypeWidget />;
};
